import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import MuiAppBar from "@mui/material/AppBar";
import { IOpenMainProps } from "../../../interfaces/IUtils";

// Icons
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { clearStorage } from "../../../utils/storage";
import { useAppDispatch } from "../../../store";
import { removeToken } from "../../../store/feature/reducers/userReducer";
import { useLogoutMutation } from "../../../store/feature/service/dashboard";

const drawerWidth = 320;
const Navbar = ({ open, setOpen }: IOpenMainProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const settings = ["Change Password", "Logout"];
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const [offset, setOffset] = useState(0);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const { pathname } = useLocation();
  const param = useParams();
  const [
    UserLogout,
    {
      data: logoutPayload,
      isLoading: logoutLoading,
      isSuccess: logoutSuccess,
      isError: logoutError,
    },
  ] = useLogoutMutation();
  const breadcrumb: any = [{ label: "Dashboard", href: "/" }];

  // REGION: BREADCRUMB NON DYMANIC
  if (pathname === "/sign") {
    breadcrumb.push({ label: "Sign", href: "/sign" });
  } else if (pathname === "/key/create") {
    breadcrumb.push({ label: "Key", href: "/key" });
    breadcrumb.push({ label: "Create Key ", href: "/key/create" });
  } else if (pathname === `/key/detail`) {
    breadcrumb.push({ label: "Key", href: "/key" });
    breadcrumb.push({ label: "Detail Key ", href: `/key/detail` });
  } else if (pathname === "/verify") {
    breadcrumb.push({ label: "Verify", href: "/verify" });
  } else if (pathname === "/encrypt") {
    breadcrumb.push({ label: "Encrypt", href: "/encrypt" });
  } else if (pathname === "/decrypt") {
    breadcrumb.push({ label: "Decrypt", href: "/decrypt" });
  }

  //Tokenization
  else if (pathname === "/tokenize") {
    breadcrumb.push({ label: "Tokenize", href: "/tokenize" });
  } else if (pathname === "/detokenize") {
    breadcrumb.push({ label: "Detokenize", href: "/detokenize" });
  } else if (pathname === "/detokenize") {
    breadcrumb.push({ label: "Detokenize", href: "/detokenize" });
  } else if (pathname === "/masking") {
    breadcrumb.push({ label: "Masking", href: "/masking" });
  } else if (pathname === "/detoken-mask") {
    breadcrumb.push({ label: "Detoken Mask", href: "/detoken-mask" });
  } else if (pathname === "/batch-tokenize") {
    breadcrumb.push({ label: "Batch Tokenize", href: "/batch-tokenize" });
  } else if (pathname === "/batch-detokenize") {
    breadcrumb.push({ label: "Batch Detokenize", href: "/batch-detokenize" });
  } else if (pathname === "/batch-mask") {
    breadcrumb.push({ label: "Batch Mask", href: "/batch-mask" });
  }
  //
  else if (pathname === "/license-server") {
    breadcrumb.push({ label: "License Server", href: "/license-server" });
  } else if (pathname === "/license-server/create") {
    breadcrumb.push({ label: "License Server", href: "/license-server" });
    breadcrumb.push({
      label: "Create License Server ",
      href: "/license-server/create",
    });
  } else if (pathname === `/license-server/license-detail/${param.id}`) {
    breadcrumb.push({ label: "License Server", href: "/license-server" });
    breadcrumb.push({
      label: "Detail License Server ",
      href: `/license-server/license-detail/${param.id}`,
    });
  } else if (pathname === `/license-server/license-detail/${param.id}/create`) {
    breadcrumb.push({ label: "License Server", href: "/license-server" });
    breadcrumb.push({
      label: "Detail License Server ",
      href: `/license-server/license-detail/${param.id}`,
    });
    breadcrumb.push({
      label: "Create License Server Detail",
      href: `/license-server/license-detail/${param.id}/create`,
    });
  }

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleButton = (setting: any) => {
    if (setting === "Logout") {
      UserLogout("");
      dispatch(removeToken());
      navigate("/home", { replace: true });
      clearStorage();
    } else if (setting === "Change Password") {
      navigate("/change-password");
    }
  };

  return (
    <MuiAppBar
      position="fixed"
      sx={{
        display: "flex",
        background: "transparent",
        // background: 'yellow',
        boxShadow: "none",
        // backgroundColor: '#B3c100',
        alignItems: "space-between",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
          marginLeft: drawerWidth,
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
    >
      <Toolbar sx={{ borderRadius: "none", paddingLeft: 0 }} variant="dense">
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 3.7,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          {offset <= 30 && (
            <Breadcrumbs
              aria-label="breadcrumb"
              sx={{
                backgroundColor: "transparent",
                flex: 1,
                marginTop: "12px",
                cursor: "pointer",
              }}
            >
              {breadcrumb.map((item: any, index: Number) => {
                return index != breadcrumb.length - 1 ? (
                  <Link
                    key={item.label}
                    onClick={() => navigate(item.href)}
                    underline="hover"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <Typography color="textPrimary">{item.label}</Typography>
                );
              })}
            </Breadcrumbs>
          )}

          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt="Remy Sharp"
                src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              />
            </IconButton>
          </Tooltip>

          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={handleCloseUserMenu}>
                {/* <Typography textAlign="center">{setting}</Typography> */}
                <Button
                  onClick={() => handleButton(setting)}
                  sx={{
                    width: "100%",
                    justifyContent: "flex-start",
                    textTransform: "none",
                    paddingX: "12px",
                  }}
                >
                  {setting}
                </Button>
              </MenuItem>
            ))}
          </Menu>
        </Box>
        {/* <Typography variant="h6" noWrap component="div">
            Mini variant drawer */}
        {/* </Typography> */}
        {/* <Navbar /> */}
      </Toolbar>
    </MuiAppBar>
  );
};

export default Navbar;
